export const stats = [
];

export const exchanges = [
  { name: "Binance", rebate: "Lên đến 50%", code: "813528158", bonus: "Hỗ trợ nhanh" },
  { name: "Bybit", rebate: "50%", code: "HoanPhi50", bonus: "Ưu đãi VIP" },
  { name: "OKX", rebate: "40%", code: "HoanPhi50", bonus: "Ưu đãi VIP" },
  { name: "BingX", rebate: "50%", code: "GRIWGP", bonus: "Copy trade" },
  { name: "Bitget", rebate: "50%", code: "rx7u7usk", bonus: "Bonus nhóm" },
  { name: "MEXC", rebate: "50%", code: "HoanPhi50", bonus: "Phù hợp altcoin" },
];

export const features = [
  {
    title: "🚀 Hoàn phí lên đến 50% mỗi lệnh",
    desc: "Giữ lại nhiều lợi nhuận hơn",
  },
  {
    title: "🤖 Bot tracking phí tự động 24/7",
    desc: "Ghi nhận phí theo thời gian thực.Tự động hoàn phí mỗi ngày - minh bạch",
  },
  {
    title: "💸 $2.3M+ đã hoàn cho 12,000+ traders",
    desc: "Có số liệu minh bạch",
  },
  {
    title: "👥 12,000+ traders đang sử dụng hệ thống",
    desc: "Có cộng đồng active & tín hiệu hỗ trợ giao dịch mỗi ngày",
  },
];

export const benefits = [
  "Hoàn phí hiển thị rõ",
  "Theo dõi trực tiếp",
  "Không chỉnh sửa",

  "Chia sẻ tín hiệu mỗi ngày",
  "Học hỏi kinh nghiệm từ các Pro Trader",

  "Admin hỗ trợ nhanh",
  "Giải đáp trực tiếp",
  "Chia sẻ kinh nghiệm thực chiến 24/7",
];

export const testimonials = [
  {
    photo: "/comments/kevinPhuc.png"
  },
  {
    photo: "/comments/Nnminh87.png"
  },
  {
    photo: "/comments/TranBang.png"
  },
];

export const faqs = [
  {
    q: "❓ TRADERLASO1 là gì?",
    a: `TraderLaso1 là hệ thống hoàn phí giao dịch kết hợp cộng đồng trader.
Bạn trade trực tiếp trên các sàn (Binance, OKX, Bybit...) và nhận hoàn phí mỗi ngày thông qua hệ thống bot tự động.

Ngoài ra, hệ thống còn có cộng đồng hỗ trợ, chia sẻ tín hiệu và kinh nghiệm giao dịch.`,
  },
  {
    q: "❓ Cộng đồng TRADERLASO1 có uy tín không?",
    a: `Hệ thống hoạt động dựa trên chương trình affiliate chính thức của các sàn.
Bạn đăng ký & giao dịch trực tiếp trên sàn — chúng tôi không giữ tiền của bạn.

Mọi dữ liệu hoàn phí đều được bot ghi nhận và hiển thị minh bạch.`,
  },
  {
    q: "❓ Có nên tham gia TRADERLASO1 không?",
    a: `Nếu bạn đang giao dịch crypto/forex, việc hoàn phí giúp giảm chi phí đáng kể.

Ngoài ra, bạn còn có:

• Cộng đồng trader hỗ trợ
• Tín hiệu & phân tích mỗi ngày
• Bot hỗ trợ 24/7`,
  },
  {
    q: "❓ Tham gia TRADERLASO1 được quyền lợi gì?",
    a: `Bạn không cần VIP vẫn có thể tham gia hệ thống miễn phí.

• Nhận hoàn phí giao dịch mỗi ngày
• Tham gia cộng đồng trader
• Cập nhật tin tức & thị trường liên tục
• Nhận tín hiệu & hỗ trợ từ hệ thống

VIP sẽ có thêm quyền lợi nâng cao (tín hiệu & hỗ trợ chuyên sâu).`,
  },
];
